// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"240":"c52453db","620":"2918af5a"}[chunkId] + ".chunk.css";
};